import debounce from 'lodash.debounce';
import Swiper, { Scrollbar, A11y, Pagination } from 'swiper';

Swiper.use([Scrollbar, A11y, Pagination]);

interface FeaturedArticlesSwiperProps {
    el: HTMLElement;
}

const FeaturedArticles = ({ el }: FeaturedArticlesSwiperProps): void => {
    const cardContainer = el.querySelector('.featured-articles-list-grid');
    const items = el.querySelectorAll('.featured-articles-list-grid > div');
    const itemsLengthClass = items.length > 8 ? 'more-than-8' : `items-${items.length}`;
    el.classList.add(itemsLengthClass);

    if (!cardContainer || !items.length) {
        return;
    }


    const constructElement = (): { swiperEl: HTMLDivElement } => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('featured-articles-list-swiper');

        const sliderEl = `<div class="featured-articles-list-container swiper">
            <div class="swiper-wrapper">
                ${cardContainer?.innerHTML}
            </div>
            <div class="swiper-pagination"></div>
        </div>
        `;

        wrapper.insertAdjacentHTML('beforeend', sliderEl);
        cardContainer.parentNode?.appendChild(wrapper);

        return { swiperEl: wrapper.querySelector('.swiper') as HTMLDivElement };
    };
    const { swiperEl } = constructElement();

    const swiperBreakpoints = {
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1280: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    };

    const FeaturedArticlesSwiper = new Swiper(swiperEl, {
        init: false,
        spaceBetween: 16,
        slidesPerView: items.length > 1 ? 1.05 : 1,
        modules: [Scrollbar],
        breakpoints: swiperBreakpoints,
        watchOverflow: true,
        watchSlidesProgress: true,
        // navigation: {
        //     nextEl,
        //     prevEl,
        // },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
        },
    });

    FeaturedArticlesSwiper.init();
    const windowResizeCheck = (): void => {
        setTimeout(() => {
            FeaturedArticlesSwiper.slideReset();
            FeaturedArticlesSwiper.update();
        }, 300);
    };

    windowResizeCheck();
    window.addEventListener('resize', debounce(windowResizeCheck, 100));
};

export default FeaturedArticles;
